import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
    Card, Modal, TextField, Typography, Tab, Tabs, CircularProgress, Switch, Tooltip, Button, FormGroup, FormControlLabel, Checkbox, FormControl, FormLabel, RadioGroup, Radio, MenuItem, TableContainer, Table, TableHead,
    TableRow, TableCell, TableBody, Paper, TablePagination
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CancelButton from 'src/components/shared/CancelButton';
import CompleteButton from 'src/components/shared/CompleteButton';
import ImageUpload from 'src/components/shared/ImageUpload';
import MultipleImageUpload from 'src/components/shared/MultipleImageUpload';
import Services from 'src/services/Services';
import moment from 'moment';
import { toast } from 'react-toastify';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './AddEditBolParaCompany.css'
import Iconify from 'src/components/iconify';
import { useLocalization } from 'src/context/LocalizationContext';
import api from 'src/services/BaseService';

export default function AddEditBolParaCompany({ open, onClose, company, companyName, setCompanyName, logo, setLogo, getCompanies }) {
    const { language } = useLocalization();
    const parsedUser = JSON.parse(localStorage.getItem('user'));

    const [campaignTitle, setCampaignTitle] = useState("");
    const [campaignPrefix, setCampaignPrefix] = useState("");
    const [campaignImages, setCampaignImages] = useState([]);
    const [campaignStart, setCampaignStart] = useState();
    const [campaignEnd, setCampaignEnd] = useState();
    const [campaignType, setCampaignType] = useState("");
    const [activeTab, setActiveTab] = useState(0);
    const [campaignList, setCampaignList] = useState([]);
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [isActive, setIsActive] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
    const [selectedCampaignIDForRemove, setSelectedCampaignIDForRemove] = useState("");

    const [selectedCampaign, setSelectedCampaign] = useState();

    const [agreement, setAgreement] = useState(EditorState.createEmpty());
    const [showAgreements, setShowAgreements] = useState(false);
    const [agreementTitle, setAgreementTitle] = useState("");
    const [agreementsArray, setAgreementsArray] = useState([]);
    const [editingAgreementIndex, setEditingAgreementIndex] = useState(null);

    const [newAgreements, setNewAgreements] = useState([]);
    const [updatedAgreements, setUpdatedAgreements] = useState([]);
    const [deletedAgreementIds, setDeletedAgreementIds] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [allPoints, setAllPoints] = useState([]);
    const [pointsData, setPointsData] = useState([]);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [selectedPoints, setSelectedPoints] = useState([]);
    const [hasForm, setHasForm] = useState("0");
    const [showPoints, setShowPoints] = useState(false);
    const [pointsFilters, setPointsFilters] = useState({
        isAmazon: false,
        isArasKargo: false,
        isEasyPoint: true,
        isEsnaf: true,
        isHepsiburada: false,
        isHepsijet: false,
        isMalKabul: false,
        isMuhaberat: false,
        isN11: false,
        isSuratkargo: false,
        isTrendyol: false,
        status: '1',
        city: '',
        district: '',
        searchText: '',
        isCorporational: '0'
    });
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);

    const handleSearchChange = (e) => {
        const { value } = e.target;
        setPointsFilters(prev => ({ ...prev, searchText: value }));
    };

    const handleCorporationalChange = (e) => {
        setPointsFilters(prev => ({ ...prev, isCorporational: e.target.value }));
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setPointsFilters(prev => ({ ...prev, [name]: checked }));
    };
    const handleRadioChange = (e) => {
        setPointsFilters(prev => ({ ...prev, status: e.target.value }));
    };
    const handleCityChange = (e) => {
        const cityCode = e.target.value;
        setPointsFilters(prev => ({ ...prev, city: cityCode, district: '' }));
        setDistricts([]);
        if (cityCode) {
            fetchTowns(cityCode);
        }
    };
    const handleDistrictChange = (e) => {
        setPointsFilters(prev => ({ ...prev, district: e.target.value }));
    };

    const handleSelectPoint = (id) => {
        setSelectedPoints(prev =>
            prev.includes(id)
                ? prev.filter(x => x !== id)
                : [...prev, id]
        );
    };

    // Şehir listesini çek
    const fetchCities = () => {
        Services.GetCities()
            .then(res => {
                if (res.data.status) {
                    // city.name ile filtreleyebilmek için name’leri kullanalım
                    setCities(res.data.result);
                } else {
                    toast.error('İl listesi alınamadı');
                }
            })
            .catch(err => console.log(err));
    };

    // Seçilen şehre göre ilçe listesini çek
    const fetchTowns = (cityCode) => {
        Services.GetTowns(cityCode)
            .then(res => {
                if (res.data.status) {
                    setDistricts(res.data.result);
                } else {
                    toast.error('İlçe listesi alınamadı');
                }
            })
            .catch(err => console.log(err));
    };

    // Hepsini seç/tümünü kaldır
    const handleSelectAll = (checked) => {
        if (checked) {
            setSelectedPoints(pointsData.map(p => p.id));
        } else {
            setSelectedPoints([]);
        }
    };


    function fetchAllPoints() {
        api
            .post('flow/get-points')
            .then((response) => {
                if (response.data.status) {
                    const result = response.data.result;
                    setAllPoints(result);
                    applyFilters(result);
                } else {
                    toast.error('Noktalar yüklenemedi');
                }
            })
            .catch((error) => toast.error(error.message));
    }

    function applyFilters(data, forcedSelected = null) {
        const toKeep = forcedSelected ?? selectedPoints;
        let filtered = data;

        // 0) Başlık filtresi (Türkçe, büyük-küçük harf duyarsız)
        if (pointsFilters.searchText) {
            const term = pointsFilters.searchText
                .toLocaleLowerCase('tr-TR')
                .trim();
            filtered = filtered.filter(item =>
                item.title
                    ?.toLocaleLowerCase('tr-TR')
                    .includes(term)
            );
        }

        // 1) Checkbox filtrelerini OR ile uygula
        const activeBoxes = Object.entries(pointsFilters)
            .filter(([key, val]) => key.startsWith('is') && val)
            .map(([key]) => key);

        if (activeBoxes.length) {
            filtered = filtered.filter(item =>
                activeBoxes.some(key => String(item[key]) === '1')
            );
        }

        // 2) Status filtresi
        filtered = filtered.filter(item =>
            String(item.status) === pointsFilters.status
        );

        // 3) Şehir filtresi
        if (pointsFilters.city) {
            const cityObj = cities.find(c => c.code === pointsFilters.city);
            const cityName = cityObj?.name || '';
            filtered = filtered.filter(item =>
                item.city?.toLocaleLowerCase('tr-TR') === cityName.toLocaleLowerCase('tr-TR')
            );
        }

        // 4) İlçe filtresi
        if (pointsFilters.district) {
            const distObj = districts.find(d => d.code === pointsFilters.district);
            const distName = distObj?.name || '';
            filtered = filtered.filter(item =>
                item.district?.toLocaleLowerCase('tr-TR') === distName.toLocaleLowerCase('tr-TR')
            );
        }

        // 5) Zorunlu seçilenleri listenin başına al
        if (toKeep.length) {
            // 5.1) Edit modundan veya önceki seçimlerden gelen ID’lere ait item’ları sırayla alın
            const forcedItems = toKeep
                .map(id => data.find(item => item.id === id))
                .filter(item => item != null);

            // 5.2) Geri kalan filtrelenmiş öğeleri belirleyin
            const forcedSet = new Set(toKeep);
            const otherItems = filtered.filter(item => !forcedSet.has(item.id));

            // 5.3) Birleştir: önce forcedItems, sonra otherItems
            filtered = [...forcedItems, ...otherItems];
        }
        //  6) Kurumsal Filtresi
        if (pointsFilters.isCorporational !== '') {
            filtered = filtered.filter(item =>
                String(item.isCorporational) === pointsFilters.isCorporational
            );
        }

        setPointsData(filtered);
    }


    useEffect(() => {
        if (company) {
            getCampaigns()
            setCompanyName(company.title)
            const logoFromUrl = {
                name: `${company.title} Logo`,
                url: company.logo
            };
            setLogo([logoFromUrl]);
            setIsActive(company?.status === "1" ? true : false)
        }
    }, [company]);

    useEffect(() => {
        fetchAllPoints();
        fetchCities();
    }, [showPoints]);

    const handleCancleAddPointTocampaign = () => {
        setShowPoints(false);
        setSelectedPoints(selectedCampaign.allowedPoints);
        setPointsFilters({
            isAmazon: false,
            isArasKargo: false,
            isEasyPoint: true,
            isEsnaf: true,
            isHepsiburada: false,
            isHepsijet: false,
            isMalKabul: false,
            isMuhaberat: false,
            isN11: false,
            isSuratkargo: false,
            isTrendyol: false,
            status: '1',
            city: '',
            district: '',
            searchText: '',
            isCorporational: '0'
        })
    }


    const handleAddOrUpdateAgreement = () => {
        const rawContentState = convertToRaw(agreement.getCurrentContent());
        const htmlContent = draftToHtml(rawContentState);
        const newAgreement = {
            title: agreementTitle,
            content: htmlContent,
            // Eğer DB'den çekilen sözleşme ise id'si olacak, yeni eklenenlerde olmayacak
        };

        if (editingAgreementIndex !== null) {
            // Mevcut sözleşme üzerinde düzenleme yapılıyor
            const currentAgreement = agreementsArray[editingAgreementIndex];
            // Eğer düzenlenen sözleşmenin DB'de kaydı varsa, güncelleme olarak işaretle
            if (selectedCampaign && currentAgreement.agreementID) {
                // updatedAgreements state'ine ekle (aynı id ile güncel veriyi ekliyoruz)
                setUpdatedAgreements(prev => [...prev, { ...newAgreement, agreementID: currentAgreement.agreementID }]);
            } else if (selectedCampaign && !currentAgreement.agreementID) {
                // Eğer düzenlenen sözleşme yeni eklenmişse, newAgreements state'i üzerinde güncelleme yap
                setNewAgreements(prev => {
                    const updated = [...prev];
                    updated[editingAgreementIndex] = newAgreement;
                    return updated;
                });
            }
            // agreementsArray üzerinde de güncelleme yap
            setAgreementsArray(prev =>
                prev.map((agr, idx) => (idx === editingAgreementIndex ? newAgreement : agr))
            );
            setEditingAgreementIndex(null);
        } else {
            // Yeni sözleşme ekleniyor
            setAgreementsArray(prev => [...prev, newAgreement]);
            if (selectedCampaign) {
                // Düzenleme modundaysak, DB'de olmayan yeni sözleşmeleri ayrı state'e ekleyelim
                setNewAgreements(prev => [...prev, newAgreement]);
            }
        }
        // Alanları sıfırla
        setAgreementTitle("");
        setAgreement(EditorState.createEmpty());
    };

    const handleEditAgreement = (index) => {
        const agr = agreementsArray[index];
        setAgreementTitle(agr.title);
        const contentBlock = htmlToDraft(agr.content);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        setAgreement(EditorState.createWithContent(contentState));
        setEditingAgreementIndex(index);
    };

    const handleDeleteAgreement = (index) => {
        const agr = agreementsArray[index];

        if (selectedCampaign) {
            if (agr.agreementID) {
                // Mevcut sözleşme ise, DB'deki kaydın silineceğini belirtiyoruz
                setDeletedAgreementIds(prev => [...prev, agr.agreementID]);
                // Güncellenmiş sözleşmeler arasında varsa, oradan da çıkaralım
                setUpdatedAgreements(prev => prev.filter(a => a.agreementID !== agr.agreementID));
            } else {
                // Yeni eklenen sözleşme ise, newAgreements state'inden de çıkaralım
                setNewAgreements(prev => prev.filter((_, i) => i !== index));
            }
        }
        setAgreementsArray(prev => prev.filter((_, i) => i !== index));

        if (editingAgreementIndex === index) {
            setEditingAgreementIndex(null);
            setAgreementTitle("");
            setAgreement(EditorState.createEmpty());
        }
    };


    const allFieldsAreValid = () => {
        if (activeTab === 0 && company) {
            if (companyName !== "" && logo.length > 0) {
                return true
            }
            else {
                return false
            }
        }

        else if (activeTab === 1 && company) {
            let isEmpty = true

            if (editorState) {
                isEmpty = convertToRaw(editorState.getCurrentContent()).blocks.every(b => b.text.trim() === "");
            }

            if (campaignTitle && campaignPrefix && !isEmpty && campaignStart && campaignEnd && campaignType) {

                return true
            }
            else {
                return false
            }
        }

        else if (activeTab === 2 && company && selectedCampaign) {
            let isEmpty = true

            if (editorState) {
                isEmpty = convertToRaw(editorState.getCurrentContent()).blocks.every(b => b.text.trim() === "");
            }

            if (campaignTitle && campaignPrefix && !isEmpty && campaignStart && campaignEnd && campaignType) {

                return true
            }
            else {
                return false
            }
        }

        else if (!company) {
            if (companyName !== "" && logo.length > 0) {
                return true
            }
            else {
                return false
            }
        }
    }

    const createCompany = () => {
        Services.CreateBolParaCompany(parsedUser.token, companyName, logo[0]?.base64)
            .then((res) => {
                if (res.data.status) {
                    toast.success("Marka başarıyla eklendi.")
                    getCompanies(parsedUser.token)
                    setIsLoading(false)
                }
                else {
                    toast.error("Marka eklenirken bir sorunla karşılaşıldı.")
                    setIsLoading(false)
                }
                handleOnClose()
            })
            .catch((err) => console.log(err));
    }

    const updateCompany = () => {

        const logoData = logo[0]?.base64 || null;

        Services.UpdateBolParaCompany(parsedUser.token, company.companyID, companyName, logoData, isActive)
            .then((res) => {
                if (res.data.status) {
                    toast.success("Marka başarıyla düzenlendi.");
                    getCompanies(parsedUser.token);
                } else {
                    toast.error("Marka düzenlenirken bir sorunla karşılaşıldı.");
                }
                setIsLoading(false);
                handleOnClose()
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
                handleOnClose()
            });
    };

    const formattedDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Aylar 0-11 arası olduğu için +1 ekleniyor
        const day = String(d.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const loadAgreements = (campaignID) => {
        setIsLoading(true);
        Services.GetBolParaAgreement(parsedUser.token, campaignID)
            .then((res) => {
                if (res.data.status) {
                    setAgreementsArray(res.data.result);
                } else {
                    setAgreementsArray([]);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
            });
    };


    const addAgreements = (campaignID) => {

        for (let i = 0; i < agreementsArray.length; i++) {
            let cleanedString = agreementsArray[i].content.replaceAll("&nbsp;", "");

            Services.AddBolParaAgreement(parsedUser.token, campaignID, agreementsArray[i].title, cleanedString)
                .then((res) => {
                    if (res.data.status) {
                        toast.success("Kampanya başarıyla eklendi.")
                        getCompanies(parsedUser.token)
                        setIsLoading(false)
                    }
                    else {
                        toast.error("Kampanya sözleşmeleri eklenirken bir sorunla karşılaşıldı.")
                        setIsLoading(false)
                    }
                    handleOnClose()
                })
                .catch((err) => console.log(err));
        }

    }

    const addAgreementsForUpdate = (campaignID, agreement) => {

        let cleanedString = agreement.content.replaceAll("&nbsp;", "");

        Services.AddBolParaAgreement(parsedUser.token, campaignID, agreement.title, cleanedString)
            .then((res) => {
                if (!res.data.status) {
                    toast.error("Kampanya sözleşmelesi eklenirken bir sorunla karşılaşıldı. " + agreement.title)
                    setIsLoading(false)
                }
                setSelectedCampaign()
            })
            .catch((err) => console.log(err));

    }

    const createCampaign = () => {
        setIsLoading(true)
        const rawContentState = convertToRaw(editorState.getCurrentContent());
        const htmlContent = draftToHtml(rawContentState);

        let cleanedString = htmlContent.replaceAll("&nbsp;", "");

        Services.CreateBolParaCampaign(parsedUser.token, campaignTitle, campaignPrefix, company.companyID, cleanedString, extractBase64Images(campaignImages), formattedDate(new Date(campaignStart)), formattedDate(new Date(campaignEnd)), campaignType, selectedPoints, hasForm)
            .then((res) => {
                if (res.data.status) {
                    if (agreementsArray.length === 0) {
                        toast.success("Kampanya başarıyla eklendi.")
                        getCompanies(parsedUser.token)
                        setIsLoading(false)
                        handleOnClose()
                    }
                    else {
                        addAgreements(res.data.result)
                    }
                }
                else {
                    toast.error("Kampanya eklenirken bir sorunla karşılaşıldı.")
                    setIsLoading(false)
                }
            })
            .catch((err) => console.log(err));
    }

    const updateCampaign = () => {
        setIsLoading(true)
        const rawContentState = convertToRaw(editorState.getCurrentContent());
        const htmlContent = draftToHtml(rawContentState);
        let cleanedString = htmlContent.replaceAll("&nbsp;", "");

        const campaignImageData = (campaignImages[0]?.file ? extractBase64Images(campaignImages) : null);

        Services.UpdateBolParaCampaign(
            parsedUser.token,
            selectedCampaign.campaignID,
            campaignTitle,
            campaignPrefix,
            company.companyID,
            cleanedString,
            campaignImageData,
            formattedDate(new Date(campaignStart)),
            formattedDate(new Date(campaignEnd)),
            campaignType,
            selectedPoints,
            hasForm
        )
            .then((res) => {
                if (res.data.status) {
                    toast.success("Kampanya başarıyla güncellendi.");

                    newAgreements.forEach(agr => {
                        addAgreementsForUpdate(selectedCampaign.campaignID, agr)
                    });

                    updatedAgreements.forEach(agr => {
                        Services.UpdateBolParaAgreement(parsedUser.token, agr.agreementID, agr.title, agr.content)
                            .then((res) => {
                                if (!res.data.status) {
                                    toast.error("Kampanya sözleşmelesi güncellenirken bir sorunla karşılaşıldı. " + agr.title);
                                }
                            }
                            )
                            .catch();
                    });
                    deletedAgreementIds.forEach(id => {
                        console.log("deleted agreements:", id);
                        Services.DeleteBolParaAgreement(parsedUser.token, id)
                            .then((res) => {
                                if (!res.data.status) {

                                }
                            }
                            )
                            .catch();
                    });
                } else {
                    toast.error("Kampanya güncellenirken bir sorunla karşılaşıldı.");
                    setIsLoading(false);
                    setSelectedCampaign();
                }
            })
            .catch((err) => console.log(err))
            .finally(() => {
                getCampaigns();
                setUpdatedAgreements([])
                setDeletedAgreementIds([])
                setAgreementsArray([])
                setNewAgreements([])
                setSelectedCampaign();
            });
    };


    const handleDeleteCampaign = (campaignID) => {
        setDeleteConfirmModal(true)
        setSelectedCampaignIDForRemove(campaignID)
    }

    const removeCampaign = () => {
        setIsLoading(true)
        setDeleteConfirmModal(false)
        Services.RemoveBolParaCampaign(parsedUser.token, selectedCampaignIDForRemove)
            .then((res) => {
                if (res.data.status) {
                    toast.success("Kampanya başarıyla kaldırıldı.")
                    getCampaigns()
                    setSelectedCampaignIDForRemove("")
                }
                else {
                    toast.error("Kampanya kaldırılırken bir sorunla karşılaşıldı.")
                    setIsLoading(false)
                    setSelectedCampaignIDForRemove("")
                }
            })
            .catch((err) => console.log(err));
    }

    const extractBase64Images = (data) => {
        return data.map(item => item.base64.base64);
    };

    const handleCampaignSelect = (campaign) => {

        const preselected = campaign.allowedPoints || [];
        setSelectedPoints(preselected);
        applyFilters(allPoints, preselected);

        const contentBlock = htmlToDraft(campaign.description);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        setEditorState(editorState);
        setSelectedCampaign(campaign)
        setCampaignTitle(campaign.title)
        setCampaignPrefix(campaign.prefix)
        setCampaignImages(campaign.images)
        setCampaignStart(moment(campaign.start * 1000))
        setCampaignEnd(moment(campaign.end * 1000))
        setCampaignType(campaign.type)
        setHasForm(campaign.hasForm ?? "0")
        loadAgreements(campaign.campaignID);
    }

    const handleComplete = () => {
        // setIsLoading(true)

        if (company && activeTab === 0) {
            updateCompany()
        }
        else if (company && activeTab === 1) {
            createCampaign()
        }

        else if (company && activeTab === 2 && selectedCampaign) {
            updateCampaign()
        }

        else if (!company) {
            createCompany()
        }
    }

    const getCampaigns = () => {
        setIsLoading(true)
        Services.GetBolParaCompanyCampaigns(parsedUser.token, company.companyID)
            .then((res) => {
                if (res.data.status) {
                    setCampaignList(res.data.result)
                    setIsLoading(false)
                }
                else {
                    setCampaignList([])
                    setIsLoading(false)
                }
            })
            .catch((err) => console.log(err));
    }

    const handleOnClose = () => {
        onClose()
        setCampaignTitle("")
        setCampaignPrefix("")
        setCampaignImages([])
        setCampaignStart()
        setCampaignEnd()
        setCampaignType("")
        setActiveTab(0)
        setCampaignList([])
        setEditorState(EditorState.createEmpty());
        setAgreement(EditorState.createEmpty());
        setSelectedCampaign()
        setHasForm("0")
    }

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        setCampaignTitle("")
        setCampaignPrefix("")
        setCampaignImages([])
        setCampaignStart()
        setCampaignEnd()
        setCampaignType("")
        setEditorState(EditorState.createEmpty());
        setAgreement(EditorState.createEmpty());
        setSelectedCampaign()
        setShowAgreements(false)
        setShowPoints(false)
        setAgreementsArray([])
        setUpdatedAgreements([])
        setDeletedAgreementIds([])
        setNewAgreements([])
        setSelectedPoints([])
        setHasForm("0")
        setPointsFilters({
            isAmazon: false,
            isArasKargo: false,
            isEasyPoint: true,
            isEsnaf: true,
            isHepsiburada: false,
            isHepsijet: false,
            isMalKabul: false,
            isMuhaberat: false,
            isN11: false,
            isSuratkargo: false,
            isTrendyol: false,
            status: '1',
            city: '',
            district: '',
            searchText: '',
            isCorporational: '0'
        })
    };

    const handleSwitchChange = () => {
        setIsActive(!isActive)
    };

    return (
        <Modal sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }} open={open}>
            <Card sx={{ padding: '25px', overflowY: 'auto', maxHeight: '95%' }}>

                {company ?
                    <div style={{ width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>

                        <Typography variant='h6'>{company.title}</Typography>
                        {!isLoading && activeTab === 0 &&
                            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                                <Typography>
                                    {language.commons.labels.active_statu}:
                                </Typography>
                                <Switch
                                    checked={isActive}
                                    onChange={handleSwitchChange}
                                    name="isActive"
                                    color="primary"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </div>
                        }
                    </div>
                    :
                    <Typography variant='h6'>{language.commons.labels.add_brand}</Typography>
                }

                {!company &&
                    <>
                        {isLoading ?
                            <div style={{ width: '250px', height: '250px', marginTop: '15px', marginBottom: '15px', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                                <CircularProgress size={22} color="error" />
                            </div>
                            :
                            <>
                                <TextField
                                    fullWidth
                                    label={language.commons.labels.brand_name + '*'}
                                    name="title"
                                    value={companyName}
                                    onChange={e => setCompanyName(e.target.value)}
                                    margin="normal"
                                />
                                <Typography sx={{ marginBottom: '10px', fontWeight: '600' }}>{language.commons.labels.logo + '*'}</Typography>
                                <ImageUpload setFiles={setLogo} files={logo} />
                            </>
                        }
                    </>
                }

                {company &&
                    <>
                        {isLoading ?
                            <div style={{ width: '250px', height: '250px', marginTop: '15px', marginBottom: '15px', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                                <CircularProgress size={22} color="error" />
                            </div>
                            :
                            <>

                                <Tabs
                                    value={activeTab} // Set initial tab index
                                    onChange={handleTabChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    centered
                                >
                                    <Tab label={language.commons.labels.update_brand} />
                                    <Tab label={language.commons.labels.add_campaing} />
                                    <Tab label={language.commons.labels.campaing_list} />
                                </Tabs>

                                {activeTab === 0 && company && (
                                    <>
                                        <TextField
                                            sx={{ marginTop: '35px' }}
                                            fullWidth
                                            label={language.commons.labels.brand_name + '*'}
                                            name="title"
                                            value={companyName}
                                            onChange={(e) => setCompanyName(e.target.value)}
                                            margin="normal"
                                        />
                                        <Typography sx={{ marginBottom: '10px', fontWeight: '600' }}>{language.commons.labels.logo + '*'}</Typography>
                                        <ImageUpload setFiles={setLogo} files={logo} />
                                    </>
                                )}

                                {activeTab === 1 && company && (
                                    <>
                                        {showAgreements ?
                                            <>
                                                <TextField
                                                    fullWidth
                                                    label={language.commons.column.title + "*"}
                                                    name="agreementTitle"
                                                    value={agreementTitle}
                                                    onChange={(e) => setAgreementTitle(e.target.value)}
                                                    margin="normal"
                                                />
                                                <div
                                                    style={{
                                                        maxWidth: '1000px',
                                                        border: '1px solid rgba(145, 158, 171, 0.24)',
                                                        padding: '15px',
                                                        borderRadius: '8px',
                                                        marginTop: '15px',
                                                    }}
                                                >
                                                    <Editor
                                                        editorClassName='editor'
                                                        editorState={agreement}
                                                        onEditorStateChange={setAgreement}
                                                        toolbar={{
                                                            options: [
                                                                'inline',
                                                                'blockType',
                                                                'fontSize',
                                                                'fontFamily',
                                                                'list',
                                                                'textAlign',
                                                                'colorPicker',
                                                                'link',
                                                                'embedded',
                                                                'emoji',
                                                                'image',
                                                                'remove',
                                                                'history',
                                                            ],
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ marginTop: '15px' }}>
                                                    <Button
                                                        onClick={handleAddOrUpdateAgreement}
                                                        variant="contained"
                                                        color="primary"
                                                    >
                                                        {editingAgreementIndex !== null ? "Güncelle" : "Ekle"}
                                                    </Button>
                                                </div>
                                                {agreementsArray.length > 0 &&
                                                    <div
                                                        style={{
                                                            flexDirection: 'column',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            width: '100%',
                                                            marginTop: '15px',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                width: '100%',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                paddingBottom: '5px',
                                                                borderBottom: '1px solid lightgray',
                                                            }}
                                                        >
                                                            <b style={{ width: '80%', textAlign: 'left' }}>Sözleşme Başlığı</b>
                                                            <div style={{ width: '20%' }} />
                                                        </div>
                                                        {agreementsArray.map((agr, index) => (
                                                            <div
                                                                key={index}
                                                                style={{
                                                                    display: 'flex',
                                                                    width: '100%',
                                                                    alignItems: 'center',
                                                                    borderBottom: '1px solid lightgray',
                                                                    padding: '8px 0',
                                                                }}
                                                            >
                                                                <p style={{ width: '80%', textAlign: 'left' }}>{agr.title}</p>
                                                                <div style={{ display: 'flex', width: '20%', justifyContent: 'flex-end' }}>
                                                                    <Tooltip title="Düzenle">
                                                                        <Iconify
                                                                            onClick={() => handleEditAgreement(index)}
                                                                            style={{ color: '#98A2B3', width: 22, height: 22, cursor: 'pointer', marginRight: '15px' }}
                                                                            icon="tabler:edit"
                                                                        />
                                                                    </Tooltip>
                                                                    <Tooltip title="Sil">
                                                                        <Iconify
                                                                            onClick={() => handleDeleteAgreement(index)}
                                                                            style={{ color: 'red', width: 22, height: 22, cursor: 'pointer' }}
                                                                            icon="hugeicons:delete-04"
                                                                        />
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                }

                                                <div style={{ marginTop: '15px', textAlign: 'right' }}>
                                                    <Button
                                                        onClick={() => {
                                                            setShowAgreements(false); setEditingAgreementIndex(null); setAgreementTitle("");
                                                            setAgreement(EditorState.createEmpty());
                                                        }}
                                                        variant="contained"
                                                        color="primary"
                                                    >
                                                        Tamam
                                                    </Button>
                                                </div>
                                            </>
                                            : <>{showPoints ? <>
                                                {showPoints && (
                                                    <div style={{
                                                        border: '1px solid rgba(0,0,0,0.12)',
                                                        borderRadius: 8,
                                                        padding: 16,
                                                        marginTop: 16,
                                                        maxWidth: 800
                                                    }}>
                                                        <Typography variant="h6" gutterBottom>
                                                            Noktalar Filtreleri
                                                        </Typography>

                                                        <FormGroup row>
                                                            {[
                                                                { field: 'isEasyPoint', label: 'EasyPoint' },
                                                                { field: 'isEsnaf', label: 'Esnaf' },
                                                                { field: 'isMalKabul', label: 'Mal Kabul' },
                                                                { field: 'isMuhaberat', label: 'Muhaberat' },
                                                                { field: 'isBox', label: 'Express' }
                                                            ].map(opt => (
                                                                <FormControlLabel
                                                                    key={opt.field}
                                                                    control={
                                                                        <Checkbox
                                                                            name={opt.field}
                                                                            checked={pointsFilters[opt.field]}
                                                                            onChange={handleCheckboxChange}
                                                                        />
                                                                    }
                                                                    label={opt.label}
                                                                />
                                                            ))}
                                                        </FormGroup>

                                                        <FormGroup row>
                                                            {[

                                                                { field: 'isAmazon', label: 'Amazon' },
                                                                { field: 'isArasKargo', label: 'Aras Kargo' },
                                                                { field: 'isHepsiburada', label: 'Hepsiburada' },
                                                                { field: 'isHepsijet', label: 'Hepsijet' },
                                                                { field: 'isN11', label: 'N11' },
                                                                { field: 'isSuratkargo', label: 'Suratkargo' },
                                                                { field: 'isTrendyol', label: 'Trendyol' },
                                                            ].map(opt => (
                                                                <FormControlLabel
                                                                    key={opt.field}
                                                                    control={
                                                                        <Checkbox
                                                                            name={opt.field}
                                                                            checked={pointsFilters[opt.field]}
                                                                            onChange={handleCheckboxChange}
                                                                        />
                                                                    }
                                                                    label={opt.label}
                                                                />
                                                            ))}
                                                        </FormGroup>

                                                        <FormControl component="fieldset" sx={{ marginTop: 2 }}>
                                                            <FormLabel component="legend">Kurumsal/Bireysel</FormLabel>
                                                            <RadioGroup
                                                                row
                                                                name="isCorporational"
                                                                value={pointsFilters.isCorporational}
                                                                onChange={handleCorporationalChange}
                                                            >
                                                                <FormControlLabel value="1" control={<Radio />} label="Kurumsal" />
                                                                <FormControlLabel value="0" control={<Radio />} label="Bireysel" />
                                                            </RadioGroup>
                                                        </FormControl>

                                                        <FormControl component="fieldset" sx={{ marginTop: 2 }}>
                                                            <FormLabel component="legend">Durum</FormLabel>
                                                            <RadioGroup
                                                                row
                                                                name="status"
                                                                value={pointsFilters.status}
                                                                onChange={handleRadioChange}
                                                            >
                                                                <FormControlLabel value="1" control={<Radio />} label="Aktif" />
                                                                <FormControlLabel value="0" control={<Radio />} label="Pasif" />
                                                            </RadioGroup>
                                                        </FormControl>

                                                        <TextField
                                                            select
                                                            label="İl"
                                                            value={pointsFilters.city}
                                                            onChange={handleCityChange}
                                                            fullWidth
                                                            sx={{ marginTop: 2 }}
                                                        >
                                                            {cities.map(c => (
                                                                <MenuItem key={c.code} value={c.code}>
                                                                    {c.name}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>

                                                        <TextField
                                                            select
                                                            label="İlçe"
                                                            value={pointsFilters.district}
                                                            onChange={handleDistrictChange}
                                                            fullWidth
                                                            sx={{ marginTop: 2 }}
                                                            disabled={!pointsFilters.city}
                                                        >
                                                            {districts.map(d => (
                                                                <MenuItem key={d.code} value={d.code}>
                                                                    {d.name}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>

                                                        <TextField
                                                            label="Ara"
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            value={pointsFilters.searchText}
                                                            onChange={handleSearchChange}
                                                            sx={{ mt: 2, mb: 2 }}
                                                        />

                                                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                                            <Button variant="contained" sx={{ marginTop: '15px' }} onClick={() => {
                                                                setSelectedPoints([])
                                                                applyFilters(allPoints);
                                                                setPage(0);
                                                            }}>
                                                                Filtrele
                                                            </Button>
                                                        </div>


                                                        {pointsData.length > 0 && (
                                                            <>
                                                                <TableContainer component={Paper} sx={{ mt: 2 }}>
                                                                    <Table size="small">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell padding="checkbox">
                                                                                    <Checkbox
                                                                                        indeterminate={
                                                                                            selectedPoints.length > 0 &&
                                                                                            selectedPoints.length < pointsData.length
                                                                                        }
                                                                                        checked={
                                                                                            pointsData.length > 0 &&
                                                                                            selectedPoints.length === pointsData.length
                                                                                        }
                                                                                        onChange={(e) => handleSelectAll(e.target.checked)}
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell><b>Başlık</b></TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {pointsData
                                                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                                .map(point => (
                                                                                    <TableRow key={point.id}>
                                                                                        <TableCell padding="checkbox">
                                                                                            <Checkbox
                                                                                                checked={selectedPoints.includes(point.id)}
                                                                                                onChange={() => handleSelectPoint(point.id)}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>{point.title}</TableCell>
                                                                                    </TableRow>
                                                                                ))
                                                                            }
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>

                                                                <TablePagination
                                                                    component="div"
                                                                    count={pointsData.length}
                                                                    page={page}
                                                                    onPageChange={(e, newPage) => setPage(newPage)}
                                                                    rowsPerPage={rowsPerPage}
                                                                    onRowsPerPageChange={e => {
                                                                        setRowsPerPage(parseInt(e.target.value, 10));
                                                                        setPage(0);
                                                                    }}
                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                    labelRowsPerPage="Satır / sayfa"
                                                                />
                                                            </>
                                                        )}


                                                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
                                                            <Button onClick={handleCancleAddPointTocampaign}>Vazgeç</Button>
                                                            <Button variant="contained" onClick={() => {
                                                                setShowPoints(false);
                                                                setPointsFilters({
                                                                    isAmazon: false,
                                                                    isArasKargo: false,
                                                                    isEasyPoint: true,
                                                                    isEsnaf: true,
                                                                    isHepsiburada: false,
                                                                    isHepsijet: false,
                                                                    isMalKabul: false,
                                                                    isMuhaberat: false,
                                                                    isN11: false,
                                                                    isSuratkargo: false,
                                                                    isTrendyol: false,
                                                                    status: '1',
                                                                    city: '',
                                                                    district: '',
                                                                    searchText: '',
                                                                    isCorporational: '0'
                                                                })
                                                            }}>
                                                                Uygula
                                                            </Button>
                                                        </div>
                                                    </div>
                                                )}
                                            </> : <>
                                                <div style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex', gap: '8px' }}>
                                                    <TextField
                                                        fullWidth
                                                        label={language.commons.column.campaign_name + '*'}
                                                        name="campaignTitle"
                                                        value={campaignTitle}
                                                        onChange={(e) => setCampaignTitle(e.target.value)}
                                                        margin="normal"
                                                    />
                                                    <TextField
                                                        fullWidth
                                                        label={'Prefix *'}
                                                        name="campaignPrefix"
                                                        value={campaignPrefix}
                                                        onChange={(e) => setCampaignPrefix(e.target.value)}
                                                        margin="normal"
                                                    />
                                                </div>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={hasForm === "1"}
                                                            onChange={(e) => setHasForm(e.target.checked ? "1" : "0")}
                                                        />
                                                    }
                                                    label="Form İle"
                                                    sx={{ mt: 1 }}
                                                />
                                                <div style={{ flexDirection: 'row', alignItems: 'center', display: 'flex', gap: '8px' }}>
                                                    <CompleteButton onClick={() => setShowAgreements(true)} label={"Hukuki Metinler"} sx={{ marginBottom: '15px', marginTop: '10px' }} />

                                                    <Button
                                                        variant="contained"
                                                        sx={{
                                                            backgroundColor: '#DC423C',
                                                            fontSize: 14,
                                                            fontFamily: 'Inter',
                                                            fontWeight: 400,
                                                            letterSpacing: 0.4,
                                                            height: 46,
                                                            borderRadius: '5px',
                                                            padding: '8px 16px 8px 16px',
                                                            gap: '6px',
                                                            marginBottom: '15px', marginTop: '10px',
                                                            '&:hover': { backgroundColor: '#B53228' },
                                                        }}
                                                        color="primary"
                                                        onClick={() => setShowPoints(true)}
                                                    >
                                                        NOKTALAR
                                                    </Button>
                                                </div>

                                                <div style={{ maxWidth: '1000px', border: '1px solid rgba(145, 158, 171, 0.24)', padding: '15px', borderRadius: '8px' }}>
                                                    <Editor
                                                        editorClassName='editor'
                                                        editorState={editorState}
                                                        onEditorStateChange={setEditorState}
                                                        toolbar={{
                                                            options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
                                                        }}
                                                    />
                                                </div>


                                                <Typography sx={{ marginTop: '10px', marginBottom: '15px', fontWeight: '600' }}>{language.commons.labels.campaign_img}</Typography>
                                                <div style={{ width: '100%' }}>
                                                    <MultipleImageUpload setFiles={setCampaignImages} files={campaignImages} />
                                                </div>

                                                <div style={{ width: '100%', marginTop: '15px', justifyContent: 'space-between', display: 'flex' }}>
                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <DatePicker
                                                            sx={{ marginRight: '8px', width: '50%' }}
                                                            format="DD/MM/YYYY"
                                                            label={language.commons.labels.start_date}
                                                            value={campaignStart}
                                                            onChange={(newValue) => {
                                                                setCampaignStart(newValue);
                                                                setCampaignEnd(null);
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <DatePicker
                                                            sx={{ width: '50%' }}
                                                            format="DD/MM/YYYY"
                                                            label={language.commons.labels.end_date}
                                                            value={campaignEnd}
                                                            minDate={campaignStart}
                                                            disabled={!campaignStart}
                                                            onChange={(newValue) => setCampaignEnd(newValue)}
                                                        />
                                                    </LocalizationProvider>
                                                </div>

                                                <TextField
                                                    fullWidth
                                                    label={language.commons.labels.campaing_type + '*'}
                                                    name="campaignType"
                                                    value={campaignType}
                                                    onChange={(e) => setCampaignType(e.target.value)}
                                                    margin="normal"
                                                />
                                            </>}</>

                                        }
                                    </>
                                )}

                                {activeTab === 2 && company && (
                                    <>  {selectedCampaign ?
                                        <>
                                            {showAgreements ?
                                                <>
                                                    <Typography sx={{ marginTop: '10px', fontWeight: '600' }}>{selectedCampaign.title}</Typography>
                                                    <TextField
                                                        fullWidth
                                                        label={language.commons.column.title + "*"}
                                                        name="agreementTitle"
                                                        value={agreementTitle}
                                                        onChange={(e) => setAgreementTitle(e.target.value)}
                                                        margin="normal"
                                                    />
                                                    <div
                                                        style={{
                                                            maxWidth: '1000px',
                                                            border: '1px solid rgba(145, 158, 171, 0.24)',
                                                            padding: '15px',
                                                            borderRadius: '8px',
                                                            marginTop: '15px',
                                                        }}
                                                    >
                                                        <Editor
                                                            editorClassName='editor'
                                                            editorState={agreement}
                                                            onEditorStateChange={setAgreement}
                                                            toolbar={{
                                                                options: [
                                                                    'inline',
                                                                    'blockType',
                                                                    'fontSize',
                                                                    'fontFamily',
                                                                    'list',
                                                                    'textAlign',
                                                                    'colorPicker',
                                                                    'link',
                                                                    'embedded',
                                                                    'emoji',
                                                                    'image',
                                                                    'remove',
                                                                    'history',
                                                                ],
                                                            }}
                                                        />
                                                    </div>
                                                    <div style={{ marginTop: '15px' }}>
                                                        <Button
                                                            onClick={handleAddOrUpdateAgreement}
                                                            variant="contained"
                                                            color="primary"
                                                        >
                                                            {editingAgreementIndex !== null ? "Güncelle" : "Ekle"}
                                                        </Button>
                                                    </div>
                                                    {agreementsArray.length > 0 &&
                                                        <div
                                                            style={{
                                                                flexDirection: 'column',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                width: '100%',
                                                                marginTop: '15px',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    width: '100%',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    paddingBottom: '5px',
                                                                    borderBottom: '1px solid lightgray',
                                                                }}
                                                            >
                                                                <b style={{ width: '80%', textAlign: 'left' }}>Sözleşme Başlığı</b>
                                                                <div style={{ width: '20%' }} />
                                                            </div>
                                                            {agreementsArray.map((agr, index) => (
                                                                <div
                                                                    key={index}
                                                                    style={{
                                                                        display: 'flex',
                                                                        width: '100%',
                                                                        alignItems: 'center',
                                                                        borderBottom: '1px solid lightgray',
                                                                        padding: '8px 0',
                                                                    }}
                                                                >
                                                                    <p style={{ width: '80%', textAlign: 'left' }}>{agr.title}</p>
                                                                    <div style={{ display: 'flex', width: '20%', justifyContent: 'flex-end' }}>
                                                                        <Tooltip title="Düzenle">
                                                                            <Iconify
                                                                                onClick={() => handleEditAgreement(index)}
                                                                                style={{ color: '#98A2B3', width: 22, height: 22, cursor: 'pointer', marginRight: '15px' }}
                                                                                icon="tabler:edit"
                                                                            />
                                                                        </Tooltip>
                                                                        <Tooltip title="Sil">
                                                                            <Iconify
                                                                                onClick={() => handleDeleteAgreement(index)}
                                                                                style={{ color: 'red', width: 22, height: 22, cursor: 'pointer' }}
                                                                                icon="hugeicons:delete-04"
                                                                            />
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    }

                                                    <div style={{ marginTop: '15px', textAlign: 'right' }}>
                                                        <Button
                                                            onClick={() => {
                                                                setShowAgreements(false); setEditingAgreementIndex(null); setAgreementTitle("");
                                                                setAgreement(EditorState.createEmpty());
                                                            }}
                                                            variant="contained"
                                                            color="primary"
                                                        >
                                                            Tamam
                                                        </Button>
                                                    </div>
                                                </> : <> {showPoints ? (
                                                    <div style={{
                                                        border: '1px solid rgba(0,0,0,0.12)',
                                                        borderRadius: 8,
                                                        padding: 16,
                                                        marginTop: 16,
                                                        maxWidth: 800
                                                    }}>
                                                        <Typography variant="h6" gutterBottom>
                                                            Noktalar Filtreleri
                                                        </Typography>

                                                        <FormGroup row>
                                                            {[
                                                                { field: 'isEasyPoint', label: 'EasyPoint' },
                                                                { field: 'isEsnaf', label: 'Esnaf' },
                                                                { field: 'isMalKabul', label: 'Mal Kabul' },
                                                                { field: 'isMuhaberat', label: 'Muhaberat' },
                                                                { field: 'isBox', label: 'Express' }
                                                            ].map(opt => (
                                                                <FormControlLabel
                                                                    key={opt.field}
                                                                    control={
                                                                        <Checkbox
                                                                            name={opt.field}
                                                                            checked={pointsFilters[opt.field]}
                                                                            onChange={handleCheckboxChange}
                                                                        />
                                                                    }
                                                                    label={opt.label}
                                                                />
                                                            ))}
                                                        </FormGroup>

                                                        <FormGroup row>
                                                            {[

                                                                { field: 'isAmazon', label: 'Amazon' },
                                                                { field: 'isArasKargo', label: 'Aras Kargo' },
                                                                { field: 'isHepsiburada', label: 'Hepsiburada' },
                                                                { field: 'isHepsijet', label: 'Hepsijet' },
                                                                { field: 'isN11', label: 'N11' },
                                                                { field: 'isSuratkargo', label: 'Suratkargo' },
                                                                { field: 'isTrendyol', label: 'Trendyol' },
                                                            ].map(opt => (
                                                                <FormControlLabel
                                                                    key={opt.field}
                                                                    control={
                                                                        <Checkbox
                                                                            name={opt.field}
                                                                            checked={pointsFilters[opt.field]}
                                                                            onChange={handleCheckboxChange}
                                                                        />
                                                                    }
                                                                    label={opt.label}
                                                                />
                                                            ))}
                                                        </FormGroup>

                                                        <FormControl component="fieldset" sx={{ marginTop: 2 }}>
                                                            <FormLabel component="legend">Kurumsal/Bireysel</FormLabel>
                                                            <RadioGroup
                                                                row
                                                                name="isCorporational"
                                                                value={pointsFilters.isCorporational}
                                                                onChange={handleCorporationalChange}
                                                            >
                                                                <FormControlLabel value="1" control={<Radio />} label="Kurumsal" />
                                                                <FormControlLabel value="0" control={<Radio />} label="Bireysel" />
                                                            </RadioGroup>
                                                        </FormControl>

                                                        <FormControl component="fieldset" sx={{ marginTop: 2 }}>
                                                            <FormLabel component="legend">Durum</FormLabel>
                                                            <RadioGroup
                                                                row
                                                                name="status"
                                                                value={pointsFilters.status}
                                                                onChange={handleRadioChange}
                                                            >
                                                                <FormControlLabel value="1" control={<Radio />} label="Aktif" />
                                                                <FormControlLabel value="0" control={<Radio />} label="Pasif" />
                                                            </RadioGroup>
                                                        </FormControl>

                                                        <TextField
                                                            select
                                                            label="İl"
                                                            value={pointsFilters.city}
                                                            onChange={handleCityChange}
                                                            fullWidth
                                                            sx={{ marginTop: 2 }}
                                                        >
                                                            {cities.map(c => (
                                                                <MenuItem key={c.code} value={c.code}>
                                                                    {c.name}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>

                                                        <TextField
                                                            select
                                                            label="İlçe"
                                                            value={pointsFilters.district}
                                                            onChange={handleDistrictChange}
                                                            fullWidth
                                                            sx={{ marginTop: 2 }}
                                                            disabled={!pointsFilters.city}
                                                        >
                                                            {districts.map(d => (
                                                                <MenuItem key={d.code} value={d.code}>
                                                                    {d.name}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>

                                                        <TextField
                                                            label="Ara"
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            value={pointsFilters.searchText}
                                                            onChange={handleSearchChange}
                                                            sx={{ mt: 2, mb: 2 }}
                                                        />


                                                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                                            <Button variant="contained" sx={{ marginTop: '15px' }} onClick={() => {
                                                                setSelectedPoints([])
                                                                applyFilters(allPoints);
                                                                setPage(0);
                                                            }}>
                                                                Filtrele
                                                            </Button>
                                                        </div>

                                                        {pointsData.length > 0 && (
                                                            <>
                                                                <TableContainer component={Paper} sx={{ mt: 2 }}>
                                                                    <Table size="small">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell padding="checkbox">
                                                                                    <Checkbox
                                                                                        indeterminate={
                                                                                            selectedPoints.length > 0 &&
                                                                                            selectedPoints.length < pointsData.length
                                                                                        }
                                                                                        checked={
                                                                                            pointsData.length > 0 &&
                                                                                            selectedPoints.length === pointsData.length
                                                                                        }
                                                                                        onChange={(e) => handleSelectAll(e.target.checked)}
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell><b>Başlık</b></TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {pointsData
                                                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                                .map(point => (
                                                                                    <TableRow key={point.id}>
                                                                                        <TableCell padding="checkbox">
                                                                                            <Checkbox
                                                                                                checked={selectedPoints.includes(point.id)}
                                                                                                onChange={() => handleSelectPoint(point.id)}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>{point.title}</TableCell>
                                                                                    </TableRow>
                                                                                ))
                                                                            }
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>

                                                                <TablePagination
                                                                    component="div"
                                                                    count={pointsData.length}
                                                                    page={page}
                                                                    onPageChange={(e, newPage) => setPage(newPage)}
                                                                    rowsPerPage={rowsPerPage}
                                                                    onRowsPerPageChange={e => {
                                                                        setRowsPerPage(parseInt(e.target.value, 10));
                                                                        setPage(0);
                                                                    }}
                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                    labelRowsPerPage="Satır / sayfa"
                                                                />
                                                            </>
                                                        )}


                                                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
                                                            <Button onClick={handleCancleAddPointTocampaign}>Vazgeç</Button>
                                                            <Button variant="contained" onClick={() => {
                                                                setShowPoints(false);
                                                                setPointsFilters({
                                                                    isAmazon: false,
                                                                    isArasKargo: false,
                                                                    isEasyPoint: true,
                                                                    isEsnaf: true,
                                                                    isHepsiburada: false,
                                                                    isHepsijet: false,
                                                                    isMalKabul: false,
                                                                    isMuhaberat: false,
                                                                    isN11: false,
                                                                    isSuratkargo: false,
                                                                    isTrendyol: false,
                                                                    status: '1',
                                                                    city: '',
                                                                    district: '',
                                                                    searchText: '',
                                                                    isCorporational: '0'
                                                                })
                                                            }}>
                                                                Uygula
                                                            </Button>
                                                        </div>
                                                    </div>
                                                ) : <>
                                                    <div style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex', gap: '8px' }}>
                                                        <TextField
                                                            fullWidth
                                                            label={language.commons.column.campaign_name + '*'}
                                                            name="campaignTitle"
                                                            value={campaignTitle}
                                                            onChange={(e) => setCampaignTitle(e.target.value)}
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            fullWidth
                                                            label={'Prefix *'}
                                                            name="campaignPrefix"
                                                            value={campaignPrefix}
                                                            onChange={(e) => setCampaignPrefix(e.target.value)}
                                                            margin="normal"
                                                        />
                                                    </div>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={hasForm === "1"}
                                                                onChange={(e) => setHasForm(e.target.checked ? "1" : "0")}
                                                            />
                                                        }
                                                        label="Form İle"
                                                        sx={{ mt: 1 }}
                                                    />
                                                    <div style={{ flexDirection: 'row', alignItems: 'center', display: 'flex', gap: '8px' }}>
                                                        <CompleteButton onClick={() => setShowAgreements(true)} label={"Hukuki Metinler"} sx={{ marginBottom: '15px', marginTop: '10px' }} />

                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                backgroundColor: '#DC423C',
                                                                fontSize: 14,
                                                                fontFamily: 'Inter',
                                                                fontWeight: 400,
                                                                letterSpacing: 0.4,
                                                                height: 46,
                                                                borderRadius: '5px',
                                                                padding: '8px 16px 8px 16px',
                                                                gap: '6px',
                                                                marginBottom: '15px', marginTop: '10px',
                                                                '&:hover': { backgroundColor: '#B53228' },
                                                            }}
                                                            color="primary"
                                                            onClick={() => setShowPoints(true)}
                                                        >
                                                            NOKTALAR
                                                        </Button>
                                                    </div>
                                                    <div style={{ width: '800px', border: '1px solid rgba(145, 158, 171, 0.24)', padding: '15px', borderRadius: '8px' }}>
                                                        <Editor
                                                            editorClassName='editor'
                                                            editorState={editorState}
                                                            onEditorStateChange={setEditorState}
                                                            toolbar={{
                                                                options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
                                                            }}
                                                        />
                                                    </div>


                                                    <Typography sx={{ marginTop: '10px', marginBottom: '15px', fontWeight: '600' }}>{language.commons.labels.campaign_img}</Typography>
                                                    <div style={{ width: '100%' }}>
                                                        <MultipleImageUpload setFiles={setCampaignImages} files={campaignImages} />
                                                    </div>

                                                    <div style={{ width: '100%', marginTop: '15px', justifyContent: 'space-between', display: 'flex' }}>
                                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                                            <DatePicker
                                                                sx={{ marginRight: '8px', width: '50%' }}
                                                                format="DD/MM/YYYY"
                                                                label={language.commons.labels.start_date}
                                                                value={campaignStart}
                                                                onChange={(newValue) => {
                                                                    setCampaignStart(newValue);
                                                                    setCampaignEnd(null);
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                                            <DatePicker
                                                                sx={{ width: '50%' }}
                                                                format="DD/MM/YYYY"
                                                                label={language.commons.labels.start_date}
                                                                value={campaignEnd}
                                                                minDate={campaignStart}
                                                                disabled={!campaignStart}
                                                                onChange={(newValue) => setCampaignEnd(newValue)}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>

                                                    <TextField
                                                        fullWidth
                                                        label={language.commons.labels.campaing_type + '*'}
                                                        name="campaignType"
                                                        value={campaignType}
                                                        onChange={(e) => setCampaignType(e.target.value)}
                                                        margin="normal"
                                                    />
                                                </>}</>
                                            }

                                        </>
                                        :
                                        <>
                                            {
                                                <div style={{ minWidth: '650px' }}>

                                                    {campaignList.length > 0 ?

                                                        <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                                                            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: '15px', paddingBottom: '5px', borderBottom: '1px solid lightgray' }}>
                                                                <b style={{ width: '30%', textAlign: 'left' }}>{language.commons.column.title}</b>
                                                                <b style={{ width: '20%', textAlign: 'left' }}>Prefix</b>
                                                                <b style={{ width: '25%', textAlign: 'left' }}>{language.commons.column.beginning}</b>
                                                                <b style={{ width: '25%', textAlign: 'left' }}>{language.commons.column.finish}</b>
                                                                <div style={{ width: '74px' }} />
                                                            </div>
                                                            {campaignList.map((campaign, index) => (
                                                                <div key={index} style={{
                                                                    flexDirection: 'row', display: 'flex', width: '100%', alignItems: 'center', borderBottom: '1px solid lightgray'
                                                                }}>
                                                                    <div

                                                                        onClick={() => handleCampaignSelect(campaign)}
                                                                        onMouseEnter={() => setHoveredItem(index)} // Sadece bu öğe hover olduğunda
                                                                        onMouseLeave={() => setHoveredItem(null)} // Hover kaldırıldığında
                                                                        style={{
                                                                            flexDirection: 'row',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'space-between',
                                                                            width: '100%',
                                                                            cursor: 'pointer',
                                                                            backgroundColor: hoveredItem === index ? '#F9FAFB' : 'transparent', // Sadece bu öğe hover edildiğinde renk değişimi
                                                                        }}
                                                                    >
                                                                        <p style={{ width: '30%', textAlign: 'left' }}>{campaign.title}</p>
                                                                        <p style={{ width: '20%', textAlign: 'left' }}>{campaign.prefix}</p>
                                                                        <p style={{ width: '25%', textAlign: 'left' }}>
                                                                            {moment.unix(campaign.start).format('DD/MM/YYYY')}
                                                                        </p>
                                                                        <p style={{ width: '25%', textAlign: 'left' }}>
                                                                            {moment.unix(campaign.end).format('DD/MM/YYYY')}
                                                                        </p>
                                                                    </div>
                                                                    <Tooltip title={language.commons.edit}>
                                                                        <Iconify onClick={() => handleCampaignSelect(campaign)} style={{ color: '#98A2B3', width: 22, height: 22, cursor: 'pointer', marginRight: '15px' }} icon="tabler:edit" />
                                                                    </Tooltip>
                                                                    <Tooltip title={language.commons.remove}>
                                                                        <Iconify onClick={() => handleDeleteCampaign(campaign.campaignID)} style={{ color: 'red', width: 22, height: 22, cursor: 'pointer', marginRight: '15px' }} icon="hugeicons:delete-04" />
                                                                    </Tooltip>
                                                                </div>

                                                            ))}
                                                        </div>
                                                        :
                                                        <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', marginTop: '15px' }}>
                                                            <p>{language.commons.warnings.no_campaing}</p>
                                                        </div>}
                                                </div>

                                            }

                                        </>
                                    }

                                    </>
                                )}
                            </>
                        }
                    </>
                }

                <Dialog
                    open={deleteConfirmModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >

                    <DialogTitle id="alert-dialog-title">{"Emin misiniz?"}</DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Kampanyayı kaldırmak istediğinize emin misiniz ?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDeleteConfirmModal(false)}>Hayır</Button>
                        <Button onClick={removeCampaign}>Evet</Button>
                    </DialogActions>
                </Dialog>


                {activeTab !== 2 && !isLoading && !showAgreements && !showPoints &&

                    <div style={{ width: '100%', alignItems: 'center', justifyContent: 'flex-end', gap: '15px', display: 'flex', marginTop: '15px' }}>
                        <CancelButton onClick={handleOnClose} label={"Vazgeç"} />
                        <CompleteButton disabled={!allFieldsAreValid()} onClick={handleComplete} label={"Kaydet"} />
                    </div>
                }

                {activeTab === 2 && !isLoading && !showAgreements && !showPoints &&

                    <div style={{ width: '100%', alignItems: 'center', justifyContent: 'flex-end', gap: '15px', display: 'flex', marginTop: '15px' }}>
                        {!selectedCampaign && <CancelButton onClick={handleOnClose} label={"Kapat"} />}
                        {selectedCampaign && <><CancelButton onClick={() => setSelectedCampaign()} label={"Geri"} /><CompleteButton disabled={!allFieldsAreValid()} onClick={handleComplete} label={"Kaydet"} /></>}
                    </div>
                }

            </Card>
        </Modal >
    )
}
